// Autogenerated by util/sync-labels/sync-labels.ts
// Do not edit this file directly.
// To regenerate this file, start ithriv_landing_service locally on port 8000 and
// run the following command in the root directory of the ithriv_web repository:
// > npm run sync_labels
import {LabelResponse} from '@backend';

export enum OtherSensitiveData {
  NONE = 'none',
  HIV_STATUS = 'hiv-status',
  PSYCHIATRIC = 'psychiatric',
  FINANCIAL = 'financial',
  EMPLOYMENT = 'employment',
  STUDENT = 'student',
  CONSUMER = 'consumer',
  CRIMINAL = 'criminal',
  ADDICTION_STATUS = 'addiction-status',
  SEXUAL_HEALTH = 'sexual-health',
  GENDER = 'gender',
  PII = 'pii',
  SSN = 'ssn',
  CUI = 'cui',
  OTHER_SENSITIVE = 'other-sensitive',
}

export const OtherSensitiveDataLabels = {
  none: 'NONE',
  'hiv-status': 'HIV Status',
  psychiatric: 'Psychiatric',
  financial: 'Financial',
  employment: 'Employment',
  student: 'Student',
  consumer: 'Consumer',
  criminal: 'Criminal',
  'addiction-status': 'Addiction status',
  'sexual-health': 'Sexual Health',
  gender: 'Gender Identity',
  pii: 'Personally Identifiable Information',
  ssn: 'Social Security Number',
  cui: 'Controlled Unclassified Information (CUI)',
  'other-sensitive': 'Other Sensitive',
} as const;

export type OtherSensitiveDataId = keyof typeof OtherSensitiveDataLabels;
export type OtherSensitiveDataLabel = (typeof OtherSensitiveDataLabels)[OtherSensitiveDataId];

export const OtherSensitiveDataOptions: Record<OtherSensitiveData, LabelResponse> = {
  none: {
    id: OtherSensitiveData.NONE,
    text: OtherSensitiveDataLabels[OtherSensitiveData.NONE],
    sensitivity_level_id: null,
    display_order: 1,
  },
  'hiv-status': {
    id: OtherSensitiveData.HIV_STATUS,
    text: OtherSensitiveDataLabels[OtherSensitiveData.HIV_STATUS],
    sensitivity_level_id: null,
    display_order: 2,
  },
  psychiatric: {
    id: OtherSensitiveData.PSYCHIATRIC,
    text: OtherSensitiveDataLabels[OtherSensitiveData.PSYCHIATRIC],
    sensitivity_level_id: null,
    display_order: 3,
  },
  financial: {
    id: OtherSensitiveData.FINANCIAL,
    text: OtherSensitiveDataLabels[OtherSensitiveData.FINANCIAL],
    sensitivity_level_id: null,
    display_order: 4,
  },
  employment: {
    id: OtherSensitiveData.EMPLOYMENT,
    text: OtherSensitiveDataLabels[OtherSensitiveData.EMPLOYMENT],
    sensitivity_level_id: null,
    display_order: 5,
  },
  student: {
    id: OtherSensitiveData.STUDENT,
    text: OtherSensitiveDataLabels[OtherSensitiveData.STUDENT],
    sensitivity_level_id: null,
    display_order: 6,
  },
  consumer: {
    id: OtherSensitiveData.CONSUMER,
    text: OtherSensitiveDataLabels[OtherSensitiveData.CONSUMER],
    sensitivity_level_id: null,
    display_order: 7,
  },
  criminal: {
    id: OtherSensitiveData.CRIMINAL,
    text: OtherSensitiveDataLabels[OtherSensitiveData.CRIMINAL],
    sensitivity_level_id: null,
    display_order: 8,
  },
  'addiction-status': {
    id: OtherSensitiveData.ADDICTION_STATUS,
    text: OtherSensitiveDataLabels[OtherSensitiveData.ADDICTION_STATUS],
    sensitivity_level_id: null,
    display_order: 9,
  },
  'sexual-health': {
    id: OtherSensitiveData.SEXUAL_HEALTH,
    text: OtherSensitiveDataLabels[OtherSensitiveData.SEXUAL_HEALTH],
    sensitivity_level_id: null,
    display_order: 10,
  },
  gender: {
    id: OtherSensitiveData.GENDER,
    text: OtherSensitiveDataLabels[OtherSensitiveData.GENDER],
    sensitivity_level_id: null,
    display_order: 11,
  },
  pii: {
    id: OtherSensitiveData.PII,
    text: OtherSensitiveDataLabels[OtherSensitiveData.PII],
    sensitivity_level_id: null,
    display_order: 12,
  },
  ssn: {
    id: OtherSensitiveData.SSN,
    text: OtherSensitiveDataLabels[OtherSensitiveData.SSN],
    sensitivity_level_id: null,
    display_order: 13,
  },
  cui: {
    id: OtherSensitiveData.CUI,
    text: OtherSensitiveDataLabels[OtherSensitiveData.CUI],
    sensitivity_level_id: null,
    display_order: 14,
  },
  'other-sensitive': {
    id: OtherSensitiveData.OTHER_SENSITIVE,
    text: OtherSensitiveDataLabels[OtherSensitiveData.OTHER_SENSITIVE],
    sensitivity_level_id: null,
    display_order: 15,
  },
} as const;
